import styled from "styled-components";

export const AttemptsContainer = styled.div`
  background: ${({ theme }) => theme.colors.lightGrayishBlue};
  padding: 1rem 1rem 1rem 2rem;
`;

export const AttemptsTitle = styled.div`
  font-weight: bold;
  margin: 1rem 0;
`;

export const AttemptsBefore = styled.div`
  margin: 1.5rem 19px 3rem 0rem;
`;

export const AttemptsReIcon = styled.span`
  display: inline-block;
  margin: auto 1rem;
  padding-top: 0.2rem;
`;

export const AttemptsAfter = styled.div<{ isRebuke: boolean }>`
  box-sizing: border-box;

  width: 100%;
  min-height: 50px;
  margin: 2rem auto;
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => props => (props.isRebuke ? theme.colors.red : theme.colors.chartGreen100)};
  border-radius: 4px;

  display: flex;
  align-items: center;
`;

export const Checkbox = styled.span`
  display: inline-block;
  margin: auto 1rem;
`;

export const ChoiceItem = styled.div`
  box-sizing: border-box;

  min-height: 43px;
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.highlightLightGrey};
  border-radius: 4px;

  width: 100%;
  display: flex;
  align-items: center;
`;

export const ChoiceItemContainer = styled.div`
  display: block;
  padding-right: 19px;
`;

export const ChoiceGraph = styled.div<{ isFilterActive: boolean }>`
  display: block;
  width: 100%;
  height: ${props => (props.isFilterActive ? "80px" : "50px")};
  margin: ${props => (props.isFilterActive ? "0px 0 -13px -9px" : "-13px 0 15px -9px")};
`;

export const ChoiceContainer = styled.div`
  width: 100%;
  margin: 1.5rem 0;
`;

export const AttemptsNote = styled.span`
  font-style: italic;
  font-size: smaller;
`;
